<a
  [routerLink]="{ cxRoute: routeForLocalization, params: routeModel } | cxUrl"
  [tabIndex]="tabIndex"
>
  <span class="text" title="{{ property }}">
    <p>
      {{ property }}
    </p>
  </span>
</a>
